export type Scorecard = {
  id: string
  scorecardPresetId?: string
  createdAt: string
  updatedAt: string
  descriptor: { [key: string]: any }
  description: string
  name: string
  type: string
  aiFeatureIds: string[]
  tags: string[]
  systemPreset: boolean
  config: ScorecardConfig
  metadata?: string
  isManagedByEnterprise: boolean
}

export type ScorecardConfig = {
  userLevel: boolean
  includeAdditionalSources: boolean
  includeInCreateClientProfile: boolean
}

export type ScorecardResult = {
  id: string
  scorecardId: string
  userId: string
  createdAt: string
  result: { [key: string]: any }
  source: { [key: string]: any }
  changes: { [key: string]: any }
  resultMetadata: { [key: string]: any }
  revision: number
}

export type ScorecardResultCreate = {
  scorecardId: string
  userId: string
  result: { [key: string]: any }
  source: { [key: string]: any }
  previousRevision: number
}

export enum ScorecardType {
  CLIENT_PROFILE = 'clientProfile',
  FORM = 'form',
}
